import AirconRepairIcon from "@/assets/images/3d-icons/aircon-repair.png";
import AirconServiceIcon from "@/assets/images/3d-icons/aircon.png";
import BabysittingIcon from "@/assets/images/3d-icons/babysitter.png";
import ChemicalOverhaulIcon from "@/assets/images/3d-icons/chemical-overhaul.png";
import ChemicalWashIcon from "@/assets/images/3d-icons/chemical-wash.png";
import CompressorIcon from "@/assets/images/3d-icons/compressor-wash.png";
import CurtainIcon from "@/assets/images/3d-icons/curtain.png";
import DeepCleaningIcon from "@/assets/images/3d-icons/deep-cleaning.png";
import ElderCareIcon from "@/assets/images/3d-icons/eldercare.png";
import ElectricianIcon from "@/assets/images/3d-icons/electrician.png";
import FloorPolishingIcon from "@/assets/images/3d-icons/floor-polishing.png";
import GasTopUpIcon from "@/assets/images/3d-icons/gas-top-up.png";
import HandymanIcon from "@/assets/images/3d-icons/handyman.png";
import ManiPediIcon from "@/assets/images/3d-icons/home-beauty.png";
import HomeCleaningIcon from "@/assets/images/3d-icons/home-cleaning.png";
import HomeMassageIcon from "@/assets/images/3d-icons/home-massage.png";
import LashesIcon from "@/assets/images/3d-icons/lashes.png";
import MattressIcon from "@/assets/images/3d-icons/mattress-cleaning.png";
import PestIcon from "@/assets/images/3d-icons/pest-cotrol.png";
import PetGroomingIcon from "@/assets/images/3d-icons/pet-grooming.png";
import PetSittingIcon from "@/assets/images/3d-icons/pet-sitting.png";
import PlumbingIcon from "@/assets/images/3d-icons/plumbing.png";
import CarpetIcon from "@/assets/images/3d-icons/rug.png";
import SofaIcon from "@/assets/images/3d-icons/sofa.png";
import {
  ChristmasBackground,
  ChristmasBanner,
  CnyBackground,
  CnyBanner,
  NationalDayBackground,
  NationalDayBanner,
} from "@/assets/images/background-theme";
import BlueStarBackgroundImage from "@/assets/images/blue-star-background-bold.png";
import { RECOMMENDED_SERVICE_IMAGES } from "@/assets/images/recommended-services";
import type { RecommendedService } from "@/components/shared/recommended-card";
import { app } from "@/config/env";
import type {
  AirconServiceName,
  BetaServiceName,
  ServiceName,
} from "@/types/service";

const theme = app.APP_THEME;
export const getBackgroundTheme = () => {
  switch (theme) {
    case "cny":
      return CnyBackground;
    case "christmas":
      return ChristmasBackground;
    case "nationalDay":
      return NationalDayBackground;
    // add other themes if provided here
    default:
      return BlueStarBackgroundImage;
  }
};

export const getBannerTheme = () => {
  switch (theme) {
    case "cny":
      return CnyBanner;
    case "christmas":
      return ChristmasBanner;
    case "nationalDay":
      return NationalDayBanner;
    // add other themes if provided here
    default:
      return false;
  }
};

export const ServiceCategoryMap = {
  Popular: "Popular Services",
  Cleaning: "Cleaning & Maintenance",
  Aircon: "Aircon Services",
  Beauty: "Beauty & Personal Care",
  Child: "Child & Eldercare",
  Pet: "Pet Care",
  Repair: "Home Repairs & Improvement",
  Pest: "Pest & Hygiene Control",
};

export const ServiceCategoryKeyList = Object.keys(
  ServiceCategoryMap,
) as ServiceCategoryKey[];

export type ServiceCategory = typeof ServiceCategoryMap;
export type ServiceCategoryKey = keyof ServiceCategory;

export type ServiceItem = {
  title: string;
  name: ServiceName | AirconServiceName | BetaServiceName;
  icon: string;
  categories: Array<keyof ServiceCategory>;
  link?: string;
};

export type BetaServiceItem = {
  title: string;
  name: BetaServiceName;
  icon: string;
  link: string;
  categories: Array<keyof ServiceCategory>;
};

const landingPageDomain = app.LANDING_PAGE_DOMAIN;
export function betaServiceItems(): BetaServiceItem[] {
  const items: BetaServiceItem[] = [
    {
      title: "Handyman",
      name: "handyman",
      icon: HandymanIcon,
      link: `${landingPageDomain}/services/handyman`,
      categories: ["Repair"],
    },
    // still un hold pending on vertical lead babysitter
    {
      title: "Babysitter",
      name: "babysitter",
      icon: BabysittingIcon,
      link: `${landingPageDomain}/services/babysitter`,
      categories: ["Child"],
    },
    {
      title: "Plumbing",
      name: "plumbing",
      icon: PlumbingIcon,
      link: `${landingPageDomain}/services/plumbing`,
      categories: ["Repair"],
    },
    {
      title: "Electrician",
      name: "electrician",
      icon: ElectricianIcon,
      link: `${landingPageDomain}/services/electrician`,
      categories: ["Repair"],
    },
    {
      title: "Floor Polishing",
      name: "floor-polishing",
      icon: FloorPolishingIcon,
      link: `${landingPageDomain}/services/floor-polishing`,
      categories: ["Cleaning"],
    },
    {
      title: "Pest Control",
      name: "pest-control",
      icon: PestIcon,
      link: `${landingPageDomain}/services/pest-control`,
      categories: ["Pest"],
    },
  ];

  return items;
}

export function otherServiceItems(): ServiceItem[] {
  const items: ServiceItem[] = [
    {
      title: "Deep Cleaning",
      name: "deep-cleaning",
      icon: DeepCleaningIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Sofa Cleaning",
      name: "sofa-cleaning",
      icon: SofaIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Carpet Cleaning",
      name: "rug-cleaning",
      icon: CarpetIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Curtain Cleaning",
      name: "curtain-cleaning",
      icon: CurtainIcon,
      categories: ["Cleaning"],
    },
    {
      title: "General Servicing",
      name: "general-servicing",
      icon: AirconServiceIcon,
      categories: ["Aircon"],
    },
    {
      title: "Chemical Wash",
      name: "chemical-wash",
      icon: ChemicalWashIcon,
      categories: ["Aircon"],
    },
    {
      title: "Compressor Wash",
      name: "compressor-wash",
      icon: CompressorIcon,
      categories: ["Aircon"],
    },
    {
      title: "Gas Top Up",
      name: "gas-top-up",
      icon: GasTopUpIcon,
      categories: ["Aircon"],
    },
    {
      title: "Chemical Overhaul",
      name: "chemical-overhaul",
      icon: ChemicalOverhaulIcon,
      categories: ["Aircon"],
    },
    {
      title: "Mattress Cleaning",
      name: "mattress-cleaning",
      icon: MattressIcon,
      categories: ["Popular", "Cleaning"],
    },
    {
      title: "Repair & Diagnostics",
      name: "aircon-service",
      icon: AirconRepairIcon,
      categories: ["Aircon"],
    },
    {
      title: "Pet Grooming",
      name: "pet-grooming",
      icon: PetGroomingIcon,
      categories: ["Pet"],
    },
    {
      title: "Pet Sitting",
      name: "pet-sitting",
      icon: PetSittingIcon,
      categories: ["Pet"],
    },
    {
      title: "Eyelash",
      name: "lashes",
      icon: LashesIcon,
      categories: ["Beauty"],
    },
    {
      title: "Eldercare",
      name: "elder-care",
      icon: ElderCareIcon,
      categories: ["Child"],
    },
    // still un hold pending on vertical lead babysitter
    // {
    //   title: "Babysitter",
    //   name: "babysitter",
    //   icon: BabysittingIcon,
    //   categories: ["Child"],
    // },
  ];
  return items;
}

export function popularServiceItems(): ServiceItem[] {
  return [
    {
      title: "Home Cleaning",
      name: "home-cleaning",
      icon: HomeCleaningIcon,
      categories: ["Popular", "Cleaning"],
    },
    {
      title: "Aircon Service",
      name: "aircon-service",
      icon: AirconServiceIcon,
      categories: ["Popular"],
    },
    {
      title: "Home Massage",
      name: "home-massage",
      icon: HomeMassageIcon,
      categories: ["Beauty"],
    },
    {
      title: "Mani Pedi",
      name: "home-beauty",
      icon: ManiPediIcon,
      categories: ["Popular", "Beauty"],
    },
  ];
}

export const recommendedServiceItems: RecommendedService[] = [
  {
    title: "Aircon Services",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedAirconServices,
    price: 16,
    name: "aircon-service",
  },
  {
    title: "Mattress Cleaning",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedMattressCleaning,
    price: 81,
    name: "mattress-cleaning",
  },
  {
    title: "Manicure Pedicure",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedManicurePedisure,
    price: 84,
    name: "home-beauty",
  },
  {
    title: "Sofa Cleaning",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedSofaCleaning,
    price: 45,
    name: "sofa-cleaning",
  },
  {
    title: "Home Massage",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedHomeMassage,
    price: 65,
    name: "home-massage",
  },
  {
    title: "Eyelash",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedEyelash,
    price: 68,
    name: "lashes",
  },
  {
    title: "Pet Grooming",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedPetGrooming,
    price: 80,
    name: "pet-grooming",
  },
  {
    title: "Chemical Wash",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedAirconChemicalWash,
    price: 68,
    name: "chemical-wash",
  },
  {
    title: "Handyman",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedHandyman,
    price: 40,
    beta: true,
    name: "handyman",
  },
  {
    title: "General Servicing",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedAirconGeneralServicing,
    price: 16,
    name: "general-servicing",
  },
  {
    title: "Chemical Overhaul",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedAirconChemicalOverhaul,
    price: 110,
    name: "chemical-overhaul",
  },
  {
    title: "Compressor Wash",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedAirconCompressorWash,
    price: 22,
    name: "compressor-wash",
  },
  {
    title: "Carpet Cleaning",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedCarpetCleaning,
    price: 72,
    name: "rug-cleaning",
  },
  {
    title: "Deep Cleaning",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedDeepCleaning,
    price: 250,
    name: "deep-cleaning",
  },
  {
    title: "Curtain Cleaning",
    imageSrc: RECOMMENDED_SERVICE_IMAGES.recommendedCurtainCleaning,
    price: 20,
    name: "curtain-cleaning",
  },
];

export function serviceItemsSectionOne(): ServiceItem[] {
  return [
    {
      title: "Home Cleaning",
      name: "home-cleaning",
      icon: HomeCleaningIcon,
      categories: ["Popular", "Cleaning"],
    },
    {
      title: "Aircon Services",
      name: "aircon-service",
      icon: AirconServiceIcon,
      categories: ["Popular"],
    },
    {
      title: "Deep Cleaning",
      name: "deep-cleaning",
      icon: DeepCleaningIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Eldercare",
      name: "elder-care",
      icon: ElderCareIcon,
      categories: ["Child"],
    },
  ];
}

export function serviceItemsSectionTwo(): ServiceItem[] {
  return [
    // still un hold pending on vertical lead babysitter
    {
      title: "Babysitting",
      name: "babysitter",
      icon: BabysittingIcon,
      categories: ["Child"],
      link: `${landingPageDomain}/services/babysitter`,
    },
    {
      title: "Massage",
      name: "home-massage",
      icon: HomeMassageIcon,
      categories: ["Beauty"],
    },
    {
      title: "Manicure Pedicure",
      name: "home-beauty",
      icon: ManiPediIcon,
      categories: ["Beauty"],
    },
    {
      title: "Pet Grooming",
      name: "pet-grooming",
      icon: PetGroomingIcon,
      categories: ["Pet"],
    },
  ];
}

export function serviceItemsSectionThree(): ServiceItem[] {
  return [
    {
      title: "Lashes",
      name: "lashes",
      icon: LashesIcon,
      categories: ["Beauty"],
    },
    {
      title: "Sofa Cleaning",
      name: "sofa-cleaning",
      icon: SofaIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Carpet Cleaning",
      name: "rug-cleaning",
      icon: CarpetIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Mattress Cleaning",
      name: "mattress-cleaning",
      icon: MattressIcon,
      categories: ["Popular", "Cleaning"],
    },
    {
      title: "Curtain Cleaning",
      name: "curtain-cleaning",
      icon: CurtainIcon,
      categories: ["Cleaning"],
    },
    {
      title: "Floor Polishing",
      name: "floor-polishing",
      icon: FloorPolishingIcon,
      categories: ["Cleaning"],
      link: `${landingPageDomain}/services/floor-polishing`,
    },
    {
      title: "Handyman",
      name: "handyman",
      icon: HandymanIcon,
      categories: ["Repair"],
      link: `${landingPageDomain}/services/handyman`,
    },
    {
      title: "Pest control",
      name: "pest-control",
      icon: PestIcon,
      categories: ["Pest"],
      link: `${landingPageDomain}/services/pest-control`,
    },
    {
      title: "Pet Sitting",
      name: "pet-sitting",
      icon: PetSittingIcon,
      categories: ["Pet"],
    },
    {
      title: "Plumbing",
      name: "plumbing",
      icon: PlumbingIcon,
      categories: ["Repair"],
      link: `${landingPageDomain}/services/plumbing`,
    },
    {
      title: "Electrician",
      name: "electrician",
      icon: ElectricianIcon,
      categories: ["Repair"],
      link: `${landingPageDomain}/services/electrician`,
    },
  ];
}
